import styled from 'styled-components'
import { dynamicProps, DynamicProps } from '~/assets/styles/props'

type FlexProps = DynamicProps

export const FlexAtom = styled.div<FlexProps>`
  display: flex;
  ${dynamicProps}
`
